module.exports = __webpack_public_path__ + "static/grzesiak_entire_page-dad5b31f3a161e8313ae94f28c777bea.jpg";